import { Component } from '@angular/core';
import { ALL_COMMON_MODULES } from '../../../shared';

@Component({
    selector: 'app-header',
    imports: [ALL_COMMON_MODULES],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {

}
